var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex items-center" }, [
    _c(
      "label",
      {
        staticClass: "block w-22 sm:w-20 flex-shrink-0 mr-2",
        attrs: { for: _vm.id },
      },
      [_vm._v(_vm._s(_vm.label))]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "w-full relative border bg-white" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "select",
        {
          staticClass:
            "relative block w-full h-11 bg-transparent pl-4 pr-11 appearance-none rounded-none z-20",
          attrs: { id: _vm.id, name: _vm.name },
          on: {
            change: function ($event) {
              return _vm.$emit("input", $event)
            },
          },
        },
        _vm._l(_vm.max + 1, function (number) {
          return _c(
            "option",
            {
              key: number - 1,
              domProps: { selected: number - 1 === parseInt(_vm.value) },
            },
            [_vm._v("\n        " + _vm._s(number - 1) + "\n      ")]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "absolute inset-y-0 right-0 flex items-center justify-center w-11 h-11 border-l pr-px z-10",
      },
      [_c("div", { staticClass: "caret bg-black" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }